// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CsloSS {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 49px;
  padding: var(--spacing-1) var(--spacing-2);
  gap: var(--spacing-2);
  font-family: var(--font-family-base);
  background-color: var(--background-alt);
  border-radius: var(--radius-s);
}

.CsloSS:nth-child(even) {
  background-color: var(--background-white);
}

.XZiIZz {
  align-items: center;
  display: flex;
  flex: 1;
  gap: var(--spacing-2);
  min-height: 33px;
}

.weE0oj {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  flex: 1;
  min-width: 210px;
}

.k8BntK {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-100);
}

.L0Rt3C,
.cCkrrX {
  flex-shrink: 0;
}

.cCkrrX {
  margin-left: 0;
}

.oNlZHJ,
.SPqUGC,
._BA_A9,
.v28ogs,
.A1pLYU,
.eI26nt {
  flex-shrink: 0;
}

.oNlZHJ,
._BA_A9,
.v28ogs,
.A1pLYU,
.eI26nt {
  width: var(--spacing-15);
}

.SPqUGC {
  width: 80px;
}

.oNlZHJ {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
}

.SPqUGC {
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  display: inline-flex;
}

._BA_A9 {
  align-items: center;
  display: flex;
  gap: var(--spacing-1-5, 12px);
  justify-content: flex-end;
}

.NCnGqp,
.uiFXap {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-sm);
}

.NCnGqp {
  font-weight: var(--font-weight-regular);
  text-align: right;
}

.ANbpdk {
  min-height: 32px !important;
}

.PMYeri {
  border-color: var(--ibk-colors-feedback-error-500, #dc2626) !important;
}

.pVou4i,
.J9zp7L,
.OCG5ib {
  padding-bottom: 6px;
  padding-top: 6px;
}

.J9zp7L {
  text-align: left;
}

.eI26nt {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.uiFXap {
  font-weight: var(--font-weight-semibold);
}

.Ef9mYE {
  flex-shrink: 0;
  width: var(--spacing-15);
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
}

.bYHEzT {
  flex-shrink: 0;
  width: var(--spacing-15);
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
}

.WavHkr {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid transparent;
  color: #1f1f1f;
  font-size: 10px;
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  white-space: nowrap;
}

.BN3BYy {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.fmQJnP {
  background-color: #eef8ec;
  border-color: #387c2b;
}

.K0dpOV {
  background-color: #fff6e6;
  border-color: #fea601;
}

.BtZz19 {
  background-color: #fee7e7;
  border-color: #dc0a0a;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryListItem/BeneficiaryListItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qBAAqB;EACrB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sEAAsE;AACxE;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".beneficiaryCard {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-height: 49px;\n  padding: var(--spacing-1) var(--spacing-2);\n  gap: var(--spacing-2);\n  font-family: var(--font-family-base);\n  background-color: var(--background-alt);\n  border-radius: var(--radius-s);\n}\n\n.beneficiaryCard:nth-child(even) {\n  background-color: var(--background-white);\n}\n\n.beneficiaryMeta {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  gap: var(--spacing-2);\n  min-height: 33px;\n}\n\n.nameSection {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  flex: 1;\n  min-width: 210px;\n}\n\n.fullName {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-100);\n}\n\n.cardStatusIcon,\n.detailsTooltip {\n  flex-shrink: 0;\n}\n\n.detailsTooltip {\n  margin-left: 0;\n}\n\n.contractType,\n.card,\n.monthlyValueContainer,\n.inputWrapper,\n.totalValueDisplay,\n.discountContainer {\n  flex-shrink: 0;\n}\n\n.contractType,\n.monthlyValueContainer,\n.inputWrapper,\n.totalValueDisplay,\n.discountContainer {\n  width: var(--spacing-15);\n}\n\n.card {\n  width: 80px;\n}\n\n.contractType {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n}\n\n.card {\n  height: 100%;\n  align-items: center;\n  justify-content: flex-start;\n  display: inline-flex;\n}\n\n.monthlyValueContainer {\n  align-items: center;\n  display: flex;\n  gap: var(--spacing-1-5, 12px);\n  justify-content: flex-end;\n}\n\n.totalLabel,\n.totalValue {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-sm);\n}\n\n.totalLabel {\n  font-weight: var(--font-weight-regular);\n  text-align: right;\n}\n\n.inputContainer {\n  min-height: 32px !important;\n}\n\n.inputError {\n  border-color: var(--ibk-colors-feedback-error-500, #dc2626) !important;\n}\n\n.valueInput,\n.businessDaysInput,\n.discountInput {\n  padding-bottom: 6px;\n  padding-top: 6px;\n}\n\n.businessDaysInput {\n  text-align: left;\n}\n\n.discountContainer {\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.totalValue {\n  font-weight: var(--font-weight-semibold);\n}\n\n.actionsColumn {\n  flex-shrink: 0;\n  width: var(--spacing-15);\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.analysisStatusColumn {\n  flex-shrink: 0;\n  width: var(--spacing-15);\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.analysisBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  color: #1f1f1f;\n  font-size: 10px;\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  white-space: nowrap;\n}\n\n.analysisBadgeIcon {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.analysisBadgeApproved {\n  background-color: #eef8ec;\n  border-color: #387c2b;\n}\n\n.analysisBadgePending {\n  background-color: #fff6e6;\n  border-color: #fea601;\n}\n\n.analysisBadgeError {\n  background-color: #fee7e7;\n  border-color: #dc0a0a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"beneficiaryCard": `CsloSS`,
	"beneficiaryMeta": `XZiIZz`,
	"nameSection": `weE0oj`,
	"fullName": `k8BntK`,
	"cardStatusIcon": `L0Rt3C`,
	"detailsTooltip": `cCkrrX`,
	"contractType": `oNlZHJ`,
	"card": `SPqUGC`,
	"monthlyValueContainer": `_BA_A9`,
	"inputWrapper": `v28ogs`,
	"totalValueDisplay": `A1pLYU`,
	"discountContainer": `eI26nt`,
	"totalLabel": `NCnGqp`,
	"totalValue": `uiFXap`,
	"inputContainer": `ANbpdk`,
	"inputError": `PMYeri`,
	"valueInput": `pVou4i`,
	"businessDaysInput": `J9zp7L`,
	"discountInput": `OCG5ib`,
	"actionsColumn": `Ef9mYE`,
	"analysisStatusColumn": `bYHEzT`,
	"analysisBadge": `WavHkr`,
	"analysisBadgeIcon": `BN3BYy`,
	"analysisBadgeApproved": `fmQJnP`,
	"analysisBadgePending": `K0dpOV`,
	"analysisBadgeError": `BtZz19`
};
module.exports = ___CSS_LOADER_EXPORT___;
